import logo from './logo.svg';
import './App.css';
import AppRouter from './config/routing';

function App() {
  return (
    <div>
      <AppRouter></AppRouter>
    </div>
  );
}

export default App;
